module.exports = __webpack_public_path__ + "img/arcade.c5e35b27.png";